import React from 'react';

export default function Loading({ loadingMessage }) {

    let message = loadingMessage && (<div className="font-bold">{loadingMessage}</div>);
    return (<div className="centeredMessage">
        <div>
            {message}
            <div className="flex justify-center m-4">
                <i className="dhicon-spin5 animate-spin text-[2.5rem]/[1rem]" />
            </div>
        </div>
    </div>);
}